import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi } from "@/hooks/useApi";
import { api, errMsg, openFile } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

function GradeRow({ s, max, onSaved }) {
  const [score, setScore] = useState(s.score ?? "");
  const [feedback, setFeedback] = useState(s.feedback || "");
  const save = async () => {
    try {
      await api.put(`/admin/submissions/${s.id}`, { score: Number(score), feedback });
      toast.success("Nilai tersimpan");
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <li className="py-4 space-y-2" data-testid={`submission-${s.id}`}>
      <div className="flex justify-between"><p className="font-medium text-sm">{s.user_name}</p><p className="text-xs text-slate-500">{fmtDateTime(s.submitted_at)}</p></div>
      {s.text && <p className="text-sm text-slate-700 whitespace-pre-line rounded bg-slate-50 p-3">{s.text}</p>}
      {s.file_id && <button className="text-xs text-amber-600 underline" onClick={() => openFile(s.file_id).catch((e) => toast.error(errMsg(e)))} data-testid={`submission-file-${s.id}`}>Buka file: {s.file_name}</button>}
      <div className="flex flex-wrap gap-2">
        <Input type="number" className="w-24" placeholder={`/${max}`} value={score} onChange={(e) => setScore(e.target.value)} data-testid={`grade-score-${s.id}`} />
        <Input className="flex-1 min-w-48" placeholder="Umpan balik" value={feedback} onChange={(e) => setFeedback(e.target.value)} data-testid={`grade-feedback-${s.id}`} />
        <Button size="sm" className="bg-slate-900" onClick={save} disabled={score === ""} data-testid={`grade-save-${s.id}`}>Simpan</Button>
      </div>
    </li>
  );
}

export default function SubmissionsDialog({ assignment, onClose }) {
  const { data, reload } = useApi(`/admin/assignments/${assignment.id}/submissions`);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="submissions-dialog">
        <DialogHeader><DialogTitle className="font-display">Pengumpulan · {assignment.title}</DialogTitle></DialogHeader>
        {data?.length === 0 && <p className="text-sm text-slate-500">Belum ada pengumpulan.</p>}
        <ul className="divide-y divide-slate-100">{(data || []).map((s) => <GradeRow key={s.id} s={s} max={assignment.max_score} onSaved={reload} />)}</ul>
      </DialogContent>
    </Dialog>
  );
}
